module.exports = __webpack_public_path__ + "static/img/12.0076774.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/12.png
// module id = +3MA
// module chunks = 0